module.exports = __webpack_public_path__ + "fd5728f2cf777b06b966d05c0c823dc9.svg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/spritesheet.svg
// module id = 1230
// module chunks = 1